// German UI texts (default language).
export const de = {
  'app.name': 'ste.box',
  'app.claim': 'Wir machen Energie zukunftssicher',

  'nav.dashboard': 'Übersicht',
  'nav.charging': 'Laden',
  'nav.heatpump': 'Wärmepumpe',
  'nav.heatpump.short': 'Wärme',
  'nav.battery': 'Speicher',
  'nav.grid': 'Netz',
  'nav.history': 'Historie',
  'nav.more': 'Mehr',
  'nav.settings': 'Einstellungen',

  'auth.title': 'Anmelden',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.totp': 'Code aus der Authenticator-App',
  'auth.submit': 'Anmelden',
  'auth.logout': 'Abmelden',
  'auth.totpHint': 'Für Ihr Konto ist die Zwei-Faktor-Anmeldung aktiv.',

  'common.loading': 'Wird geladen …',
  'common.offline': 'Keine Verbindung zum Energiemanagement',
  'common.reconnecting': 'Verbindung wird wiederhergestellt …',
  'common.error': 'Etwas ist schiefgelaufen',
  'common.retry': 'Erneut versuchen',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.noPermission': 'Diese Einstellung kann nur der Eigentümer ändern.',
  'common.today': 'Heute',
  'common.theme': 'Darstellung',
  'common.themeDark': 'Dunkel',
  'common.themeLight': 'Hell',
  'common.themeSystem': 'Wie Gerät',

  'flow.pv': 'PV',
  'flow.home': 'Haus',
  'flow.grid': 'Netz',
  'flow.battery': 'Speicher',
  'flow.import': 'Bezug',
  'flow.export': 'Einspeisung',
  'flow.charging': 'lädt',
  'flow.discharging': 'entlädt',
  'flow.idle': 'Ruhe',

  'dashboard.autarky': 'Autarkie heute',
  'dashboard.selfConsumption': 'Eigenverbrauch heute',
  'dashboard.ownShare': 'Eigenstromanteil jetzt',
  'dashboard.tariff': 'Strompreis jetzt',
  'dashboard.flow': 'Energiefluss',
  'dashboard.ownSharePill': '{value} eigener Strom',

  'mode.off': 'Aus',
  'mode.pv': 'PV',
  'mode.minpv': 'Min+PV',
  'mode.now': 'Sofort',
  'mode.heatpump.pv': 'PV-Überschuss',
  'mode.hint.off': 'Ladepunkt ist ausgeschaltet.',
  'mode.hint.pv': 'Lädt nur mit Sonnenstrom-Überschuss.',
  'mode.hint.minpv': 'Lädt sofort mit Mindestleistung, Überschuss zusätzlich.',
  'mode.hint.now': 'Lädt sofort mit voller Leistung.',
  'mode.hint.heatpump.off': 'Wärmepumpe läuft im Normalbetrieb ohne Ansteuerung.',
  'mode.hint.heatpump.pv': 'Bei Sonnenstrom-Überschuss wird die Wärmepumpe angehoben (SG-Ready).',
  'mode.hint.heatpump.now': 'Wärmepumpe wird sofort angehoben (SG-Ready).',

  'charging.title': 'Laden',
  'charging.mode': 'Lademodus',
  'charging.power': 'Ladeleistung',
  'charging.limitSoc': 'Ladeziel',
  'charging.vehicle': 'Fahrzeug',
  'charging.noVehicle': 'Kein Fahrzeug',
  'charging.session': 'Dieser Ladevorgang',
  'charging.plan': 'Zielzeit',
  'charging.planSet': 'Ziel festlegen',
  'charging.planNone': 'Keine Zielzeit gesetzt',
  'charging.planUntil': 'bis',
  'charging.notConnected': 'Nicht angeschlossen',
  'charging.connected': 'Angeschlossen',
  'charging.charging': 'Lädt',
  'charging.sessions': 'Letzte Ladevorgänge',
  'charging.noSessions': 'Noch keine Ladevorgänge',
  'charging.range': 'Reichweite',

  'heatpump.title': 'Wärmepumpe',
  'heatpump.mode': 'Betriebsart',
  'heatpump.temperature': 'Speichertemperatur',
  'heatpump.minTemperature': 'Mindesttemperatur',
  'heatpump.state': 'SG-Ready-Zustand',
  'heatpump.state.boost': 'Angehoben',
  'heatpump.state.normal': 'Normal',
  'heatpump.state.dim': 'Gedimmt (§14a)',
  'heatpump.none': 'Keine Wärmepumpe eingebunden',

  'battery.title': 'Speicher',
  'battery.soc': 'Ladestand',
  'battery.power': 'Leistung',
  'battery.prioritySoc': 'Vorrang Hausspeicher bis',
  'battery.prioritySocHint': 'Bis zu diesem Ladestand wird zuerst der Speicher geladen, danach das Fahrzeug.',
  'battery.bufferSoc': 'Fahrzeug darf Speicher nutzen ab',
  'battery.bufferSocHint': 'Oberhalb dieses Ladestands darf der Speicher beim PV-Laden mithelfen.',
  'battery.dischargeControl': 'Entladesperre beim Schnellladen',
  'battery.dischargeControlHint':
    'Verhindert, dass der Speicher beim Sofort-Laden ins Fahrzeug entladen wird.',
  'battery.none': 'Kein Speicher eingebunden',

  'grid.title': 'Netz',
  'grid.now': 'Jetzt',
  'grid.tariffGrid': 'Bezugspreis',
  'grid.tariffFeedIn': 'Einspeisevergütung',
  'grid.dimmedTitle': 'Netzbetreiber begrenzt den Verbrauch (§14a EnWG)',
  'grid.dimmedText':
    'Steuerbare Verbraucher wie Wallbox und Wärmepumpe laufen gerade mit reduzierter Leistung.',
  'grid.limit': 'Grenze',
  'grid.curtailedTitle': 'Einspeisung wird begrenzt',
  'grid.events': 'Eingriffe des Netzbetreibers',
  'grid.noEvents': 'Bisher keine Eingriffe',
  'grid.event.consumption': 'Verbrauch begrenzt',
  'grid.event.production': 'Einspeisung begrenzt',

  'history.title': 'Historie',
  'history.day': 'Tag',
  'history.week': 'Woche',
  'history.month': 'Monat',
  'history.year': 'Jahr',
  'history.generation': 'Erzeugung',
  'history.consumption': 'Verbrauch',
  'history.gridImport': 'Netzbezug',
  'history.gridExport': 'Einspeisung',
  'history.wallbox': 'Laden',
  'history.heatpump': 'Wärmepumpe',
  'history.home': 'Haus',
  'history.cost': 'Stromkosten',
  'history.revenue': 'Vergütung',
  'history.noData': 'Für diesen Zeitraum liegen noch keine Daten vor.',
  'history.powerCurve': 'Leistungsverlauf',
  'history.previous': 'Zurück',
  'history.next': 'Weiter',

  'nav.installer': 'Installateur',
  'nav.installer.short': 'Service',

  'installer.title': 'Installateur-Bereich',
  'installer.devices': 'Geräte',
  'installer.addDevice': 'Gerät hinzufügen',
  'installer.draft': 'Nicht aktivierte Änderungen',
  'installer.draftPending':
    'Änderungen sind noch nicht aktiv. evcc übernimmt neue Geräte erst nach „Prüfen“ und „Aktivieren“.',
  'installer.draftJump': 'Jetzt prüfen und aktivieren',
  'installer.discard': 'Änderungen verwerfen',
  'installer.check': 'Prüfen',
  'installer.apply': 'Aktivieren',
  'installer.applying': 'evcc wird mit der neuen Konfiguration neu gestartet …',
  'installer.applyHint':
    'evcc startet neu (einige Sekunden). Bei einem Fehler wird automatisch die vorige Konfiguration wiederhergestellt.',
  'installer.applied': 'Konfiguration aktiv',
  'installer.rolledBack': 'Neue Konfiguration fehlgeschlagen, vorige Konfiguration wiederhergestellt',
  'installer.comment': 'Kommentar (z. B. „Wallbox Garage ergänzt“)',
  'installer.revisions': 'Versionen',
  'installer.restore': 'Wiederherstellen',
  'installer.yaml': 'evcc.yaml-Vorschau',
  'installer.noIssues': 'Keine Probleme gefunden',
  // commissioning wizard, master data, house connection and §14a (ADR-0017)
  'wizard.tab': 'Assistent',
  'wizard.title': 'Inbetriebnahme-Assistent',
  'wizard.intro':
    'Schritt für Schritt durch die Inbetriebnahme. Sie können jederzeit unterbrechen und später hier weitermachen; alles ist auch einzeln in den Reitern erreichbar.',
  'wizard.step.network': 'Netzwerk',
  'wizard.step.profile': 'Stammdaten',
  'wizard.step.grid': 'Hausanschluss und §14a',
  'wizard.step.devices': 'Geräte',
  'wizard.step.tariffs': 'Tarife',
  'wizard.step.customerView': 'Kundensicht',
  'wizard.step.test': 'Test',
  'wizard.step.protocol': 'Protokoll',
  'wizard.stepOf': 'Schritt {n} von {total}',
  'wizard.back': 'Zurück',
  'wizard.next': 'Erledigt, weiter',
  'wizard.done': 'erledigt',
  'wizard.soon': 'Dieser Schritt kommt als Nächstes. Bis dahin einfach weiter.',
  'wizard.network.text':
    'Ist das Gerät per Kabel oder WLAN mit dem Internet verbunden? Auf der Netzwerk-Seite sehen Sie die Verbindung und können das WLAN des Kunden wählen.',
  'wizard.network.open': 'Netzwerk öffnen',
  'wizard.devices.text':
    'Netzzähler, Wechselrichter, Speicher, Wallbox und Wärmepumpe einrichten. Wichtig: Danach auf der Geräte-Seite unten „Prüfen“ und „Aktivieren“ tippen, erst dann übernimmt evcc die Geräte.',
  'wizard.devices.open': 'Geräte öffnen',
  'wizard.test.text': 'Prüfen, ob alle Geräte Werte liefern und evcc ohne Fehler läuft.',
  'wizard.test.open': 'Diagnose öffnen',
  'wizard.protocol.text':
    'Checkliste abhaken, Protokoll von Monteur und Kunde unterschreiben lassen und freigeben.',
  'wizard.protocol.open': 'Protokoll öffnen',
  'wizard.finished': 'Alle Schritte erledigt. Vielen Dank!',
  'profile.title': 'Stammdaten',
  'profile.customerName': 'Kunde (Name)',
  'profile.street': 'Straße und Hausnummer',
  'profile.zip': 'PLZ',
  'profile.city': 'Ort',
  'profile.gridOperator': 'Netzbetreiber',
  'profile.meterNumber': 'Zählernummer',
  'profile.commissionedAt': 'Datum der Inbetriebnahme',
  'profile.installerName': 'Zuständiger Monteur',
  'profile.saved': 'Gespeichert',
  'house.title': 'Hausanschluss',
  'house.maxCurrent': 'Hausanschluss-Sicherung (A je Phase)',
  'house.maxCurrentHint':
    'evcc regelt Wallbox und Wärmepumpe herunter, bevor diese Grenze am Netzzähler überschritten wird. Leer lassen: keine Begrenzung.',
  'house.maxCurrent14a': 'Strom für Wallbox und Wärmepumpe zusammen (A je Phase)',
  'house.maxCurrent14aHint':
    'Mit §14a-Steuerung zählt evcc nur Wallbox und Wärmepumpe, damit die Netzbetreiber-Grenze korrekt wirkt. Tragen Sie die Hausanschluss-Sicherung minus eine Reserve für den Hausverbrauch ein (z. B. 35 A − 10 A = 25 A).',
  'house.staffOnly': 'Hausanschluss, §14a und Wallbox-Grenzen ändern nur STE-Mitarbeiter.',
  'house.save': 'Speichern und aktivieren',
  'house.saved': 'Übernommen, evcc läuft mit der neuen Einstellung.',
  'house.14a': '§14a-Steuerung',
  'house.14a.none': 'Keine Steuerbox eingerichtet',
  'house.14a.device': 'Eingerichtet: {name}',
  'house.14a.add': '§14a-Gerät einrichten',
  'house.14a.ways':
    'Der Netzbetreiber steuert über die FNN-Steuerbox per EEBus (Netzwerk). Reihenfolge: 1. SKI dieses Geräts (unten) in der Steuerbox eintragen. 2. „§14a-Gerät einrichten“ mit der SKI der Steuerbox. 3. Aktivieren, während die Steuerbox erreichbar ist (evcc wartet beim Start bis zu 90 Sekunden auf sie).',
  'house.eebus.title': 'EEBus: Kennung dieses Geräts für die Steuerbox',
  'house.eebus.hint':
    'Diese SKI in der Weboberfläche der Steuerbox eintragen oder den QR-Code mit der Steuerbox-App scannen. Umgekehrt kommt die SKI der Steuerbox in das §14a-Gerät.',
  'house.eebus.ski': 'SKI dieses Geräts',
  'house.eebus.qr': 'SHIP-QR-Code für die Steuerbox',
  'house.14a.pmin':
    'Die Steuerbox sendet die aktuelle Grenze. Fällt sie aus, gilt der Failsafe-Wert (Pmin) im §14a-Gerät, Vorgabe 4.200 W; bei mehreren steuerbaren Verbrauchern den Wert aus dem Schreiben des Netzbetreibers eintragen.',
  'house.module': 'Netzentgelt-Modul (§14a)',
  'house.module.none': 'Nicht angegeben',
  'house.module.1': 'Modul 1: pauschale Reduzierung',
  'house.module.2': 'Modul 2: prozentuale Reduzierung (separater Zähler)',
  'house.module.3': 'Modul 3: zeitvariables Netzentgelt',
  // push subscriptions of STE staff (ADR-0025)
  'sites.subscribe': 'Meldungen dieser Anlage',
  'sites.subscribeHint':
    'Push-Meldungen auf Ihre Geräte, auch ohne Mitglied der Anlage zu sein. Welche Meldungen, stellen Sie unter „Meldungen“ ein.',
  // change log for customers (ADR-0024)
  'changes.title': 'Änderungsprotokoll',
  'changes.intro':
    'Wer hat wann was an der Anlage geändert, auch STE aus der Ferne. Einträge von STE-Mitarbeitern stehen mit ihrer E-Mail-Adresse.',
  'changes.none': 'Noch keine Änderungen.',
  'changes.more': 'Ältere anzeigen',
  'changes.you': 'Sie',
  'changes.failed': 'fehlgeschlagen',
  'changes.remote': 'über STE Connect',
  'changes.local': 'vor Ort',
  'changes.loadpoint': 'Ladepunkt {n}',
  'changes.fromBackup': 'aus Sicherung von {serial}',
  'changes.target.evcc': 'Energiemanagement',
  'changes.target.gateway': 'Gateway',
  'changes.role.owner': 'Eigentümer',
  'changes.role.member': 'Mitglied',
  'changes.role.installer': 'Installateur',
  'changes.role.admin': 'Administrator',
  'changes.action.config.apply': 'Anlage geändert',
  'changes.action.loadpoint.mode': 'Lademodus geändert',
  'changes.action.loadpoint.limitSoc': 'Ladeziel geändert',
  'changes.action.loadpoint.plan': 'Ladeplan gesetzt',
  'changes.action.loadpoint.plan.delete': 'Ladeplan gelöscht',
  'changes.action.loadpoint.vehicle': 'Fahrzeug gewählt',
  'changes.action.loadpoint.minTemperature': 'Mindesttemperatur der Wärmepumpe geändert',
  'changes.action.battery.settings': 'Speicher-Einstellungen geändert',
  'changes.action.installer.siteProfile': 'Stammdaten geändert',
  'changes.action.installer.customerView': 'Kundensicht geändert',
  'changes.action.installer.checklist': 'Inbetriebnahme-Checkliste bearbeitet',
  'changes.action.installer.checklist.sign': 'Inbetriebnahme-Protokoll unterschrieben',
  'changes.action.installer.checklist.share': 'Freigabe des Inbetriebnahme-Protokolls geändert',
  'changes.action.installer.checklist.reopen': 'Inbetriebnahme-Protokoll wieder geöffnet',
  'changes.action.sponsor.set': 'evcc-Sponsor-Token eingetragen',
  'changes.action.sponsor.remove': 'evcc-Sponsor-Token entfernt',
  'changes.action.network.wifi.connect': 'Mit WLAN verbunden',
  'changes.action.network.wifi.forget': 'WLAN getrennt',
  'changes.action.network.saved.forget': 'Gespeichertes WLAN entfernt',
  'changes.action.network.saved.order': 'Reihenfolge der WLANs geändert',
  'changes.action.network.setup.open': 'Einrichtungs-WLAN geöffnet',
  'changes.action.network.setup.close': 'Einrichtungs-WLAN geschlossen',
  'changes.action.maintenance.restart': 'Neu gestartet',
  'changes.action.maintenance.backup': 'Sicherung heruntergeladen',
  'changes.action.maintenance.restore': 'Sicherung eingespielt',
  'changes.action.maintenance.evccDb': 'Datenbank heruntergeladen',
  'changes.action.maintenance.log': 'Support-Protokoll heruntergeladen',
  'changes.action.maintenance.factoryReset': 'Werksreset',
  'changes.action.auth.serviceAccess': 'Installateur-Bereich mit Service-Passwort geöffnet',
  'changes.action.auth.recovery': 'Notfall-Zugang benutzt',
  // maintenance (ADR-0021)
  'maint.tab': 'Wartung',
  'maint.title': 'Wartung',
  'maint.updates': 'Updates',
  'maint.version': 'Installierte Version',
  'maint.lastUpdate': 'Letztes Update',
  'maint.lastUpdate.ok': '{version} am {date} um {time}',
  'maint.lastUpdate.rolled_back': '{version} zurückgenommen ({date})',
  'maint.lastUpdate.rolled_backHint':
    'Nach dem Update auf {version} lief die Anlage nicht richtig. Der Pi ist zu {from} mit den Daten von vorher zurückgekehrt und versucht {version} nicht noch einmal. Bitte STE Bescheid geben.',
  'maint.lastUpdate.error': '{version} nicht installiert ({date})',
  'maint.lastUpdate.errorHint':
    'Vor dem Update ließ sich keine Sicherung anlegen, vermutlich ist die Speicherkarte voll. Die Anlage läuft unverändert mit {from} weiter.',
  'maint.channel': 'Kanal',
  'maint.channel.stable': 'Stabil',
  'maint.channel.beta': 'Beta (neue Funktionen zuerst)',
  'maint.paused': 'Automatische Updates',
  'maint.pausedUntil': 'pausiert bis {date}',
  'maint.notPaused': 'aktiv (nachts)',
  'maint.pauseUntil': 'Pausieren bis einschließlich',
  'maint.unpause': 'Pause aufheben',
  'maint.updatesReadOnly': 'Kanal und Pause stellen STE-Mitarbeiter in STE Connect ein.',
  'maint.updatesHint':
    'Gilt ab dem nächsten nächtlichen Update-Lauf. Braucht auf dem Pi das Pi-Bundle ab 0.2.8.',
  'maint.restart': 'Neustart',
  'maint.restartHint':
    'Hilft, wenn Geräte keine Werte mehr liefern oder die Anzeige hängt. Der Neustart dauert etwa eine halbe Minute; Ladevorgänge laufen danach weiter.',
  'maint.restartEvcc': 'Energiemanagement (evcc) neu starten',
  'maint.restartGateway': 'Gateway neu starten',
  'maint.restartEvccConfirm': 'Energiemanagement jetzt neu starten?',
  'maint.restartGatewayConfirm':
    'Gateway jetzt neu starten? Die App ist dabei etwa eine halbe Minute nicht erreichbar.',
  'maint.restarting': 'Startet neu …',
  'maint.restarted': 'Neu gestartet, läuft wieder.',
  'maint.gatewayRestarting': 'Gateway startet neu. Die Seite lädt in einer halben Minute neu.',
  'maint.log': 'Protokoll für den Support',
  'maint.logHint':
    'Textdatei mit Versionen, Gerätestatus, Netzwerk, evcc-Log und Änderungsprotokoll, ohne Passwörter. Bei Problemen an STE schicken.',
  'maint.logDownload': 'Protokoll herunterladen',
  'maint.backup': 'Sicherung und Übertragung',
  'maint.backupHint':
    'Konfiguration, Stammdaten, Kundensicht und Inbetriebnahme-Protokoll in einer Datei, z. B. um einen Pi zu tauschen. Die Datei enthält Gerätepasswörter: vertraulich behandeln.',
  'maint.backupDownload': 'Sicherung herunterladen',
  'maint.restoreChoose': 'Sicherung einspielen …',
  'maint.evccDb': 'evcc-Datenbank (Admin)',
  'maint.restoreInvalid': 'Diese Datei ist keine STE-Sicherung.',
  'maint.restoreConfirmTitle': 'Sicherung einspielen?',
  'maint.restoreSummary': 'Anlage „{title}“, Seriennummer {serial}, gesichert am {date}.',
  'maint.restoreWarning':
    'Die Konfiguration dieses Geräts wird ersetzt und evcc startet neu. Benutzer, Kopplung und Netzwerk bleiben.',
  'maint.restoreNow': 'Jetzt einspielen',
  'maint.restoring': 'Wird eingespielt …',
  'maint.restored': 'Sicherung eingespielt, evcc läuft mit der Konfiguration.',
  'maint.reset': 'Werksreset',
  'maint.resetWarning':
    'Löscht Geräte, Tarife, Stammdaten, Kundensicht, Inbetriebnahme-Protokoll, Verlauf und Ladevorgänge dieser Anlage.',
  'maint.resetKeeps':
    'Bleiben: Benutzer, Kopplung mit STE Connect, Netzwerk, Seriennummer, Notfall-Zugang und das Änderungsprotokoll. Für einen neuen Kunden die alten Mitglieder in STE Connect entfernen.',
  'maint.resetConfirm': 'Zur Bestätigung „{text}“ eingeben',
  'maint.resetNow': 'Werksreset ausführen',
  'maint.resetFinal': 'Wirklich alles zurücksetzen? Das lässt sich nicht rückgängig machen.',
  'maint.resetting': 'Wird zurückgesetzt …',
  'maint.resetDone': 'Zurückgesetzt. Die Anlage ist im Auslieferungszustand.',
  // customer view and locked controls (ADR-0020)
  'locks.installer': 'Vom Installateur gesperrt.',
  'battery.notControllable':
    'Die Entladesperre braucht einen steuerbaren Speicher. Dieser Speicher meldet keine Steuerung an evcc.',
  'locks.fixedMode': 'Der Lademodus ist vom Installateur fest eingestellt.',
  'locks.targets': 'Ladeziel, Ladeplan und Fahrzeug sind vom Installateur gesperrt.',
  'view.tab': 'Kundensicht',
  'view.title': 'Kundensicht',
  'view.intro':
    'Was Eigentümer und Mitglieder in der App sehen und bedienen dürfen, z. B. für Firmenparkplätze oder Mieter. Installateure sehen immer alles.',
  'view.pages': 'Seiten anzeigen',
  'view.pagesHint': 'Die Übersicht ist immer sichtbar.',
  'view.page.charging': 'Laden',
  'view.page.heatpump': 'Wärme',
  'view.page.battery': 'Speicher',
  'view.page.grid': 'Netz (mit Preisen)',
  'view.page.history': 'Historie',
  'view.modes': 'Lademodus',
  'view.modeFree': 'Frei wählbar',
  'view.modesHint':
    'Ein fester Lademodus gilt auch nach dem Abstecken. Ändert er sich, startet evcc kurz neu.',
  'view.locks': 'Bedienung sperren',
  'view.lockTargets': 'Ladeziel, Ladeplan und Fahrzeug',
  'view.lockHeatPump': 'Wärmepumpe (Modus und Mindesttemperatur)',
  'view.lockBattery': 'Speicher-Einstellungen',
  'view.lockPrices': 'Preise ändern',
  'view.save': 'Speichern',
  'view.saved': 'Gespeichert. Die Kunden-App zeigt es beim nächsten Öffnen.',
  'wizard.customerView.text':
    'Seiten für den Kunden ausblenden und Bedienelemente sperren. Für Privathaushalte meist nichts ändern.',
  // heat pumps and heating rods (ADR-0019)
  'heating.tab': 'Wärme',
  'heating.title': 'Wärmepumpe und Heizstab',
  'heating.intro':
    'Leistung und Einschaltschwelle legen fest, wann evcc im PV-Modus anhebt oder einschaltet. Der Kunde wählt in der App weiter nur Aus, PV oder Sofort.',
  'heating.none': 'Noch keine Wärmepumpe und kein Heizstab eingerichtet.',
  'heating.add': 'Wärmepumpe oder Heizstab hinzufügen',
  'heating.control.sgready': 'SG-Ready über Schaltkontakte ({switch})',
  'heating.control.switch': 'Heizstab an Schaltsteckdose ({switch})',
  'heating.control.template': 'Gerätevorlage {template}',
  'heating.power': 'Leistung',
  'heating.maxPower': 'Leistung bei Volllast',
  'heating.maxPowerHint': 'Elektrische Leistung laut Datenblatt, z. B. 3000 W.',
  'heating.minPower': 'Mindestleistung',
  'heating.minPowerHint': 'Nur bei stufenlos geregelten Heizstäben. Leer: gleich der Leistung.',
  'heating.phases': 'Anschluss',
  'heating.phases.1': 'einphasig',
  'heating.phases.3': 'dreiphasig',
  'heating.pv': 'PV-Modus',
  'heating.enableSurplus': 'Einschalten ab PV-Überschuss',
  'heating.enableSurplusHint': 'Leer: sobald der Überschuss die Leistung deckt.',
  'heating.enableSurplusAuto': 'Leer: sobald der Überschuss die Leistung deckt ({power}).',
  'heating.disableImport': 'Ausschalten bei Netzbezug über',
  'heating.disableImportHint': 'Gilt nur mit Einschaltschwelle. Leer: 0 W.',
  'heating.enableDelay': 'Einschaltverzögerung',
  'heating.enableDelayHint': 'Leer: 1 Minute',
  'heating.disableDelay': 'Ausschaltverzögerung',
  'heating.disableDelayHint': 'Leer: 3 Minuten. Längere Zeiten schonen den Verdichter.',
  'heating.customerHint': 'Speichern startet evcc kurz neu (etwa eine halbe Minute).',
  'heating.invalid': 'Bitte die Leistung (100 bis 50.000 W) eintragen und die Eingaben prüfen.',
  'heating.saved': 'Übernommen, evcc regelt mit den neuen Werten.',
  'heating.comment': 'Wärme-Einstellungen {title}',
  'sgready.intro':
    'Die Wärmepumpe hat zwei SG-Ready-Eingänge. evcc schaltet sie über zwei Schaltgeräte, z. B. Shelly-Relais: Kontakt 2 hebt bei PV-Überschuss an, Kontakt 1 sperrt bei §14a-Dimmung (optional).',
  'sgready.boost': 'Anhebung (SG-Ready Kontakt 2)',
  'sgready.dim': 'Sperre (SG-Ready Kontakt 1)',
  'sgready.dimHint': 'Optional, für die Dimmung nach §14a.',
  'sgready.switch': 'Schaltgerät',
  'sgready.none': 'Keins',
  // tariffs (ADR-0018)
  'tariffs.tab': 'Tarife',
  'tariffs.title': 'Tarife',
  'tariffs.grid': 'Strompreis (Bezug)',
  'tariffs.kind.fixed': 'Fester Preis',
  'tariffs.kind.dynamic': 'Dynamischer Tarif',
  'tariffs.kind.none': 'Keiner',
  'tariffs.price': 'Arbeitspreis brutto',
  'tariffs.zonesHint':
    'Optional: andere Preise zu bestimmten Zeiten, z. B. Nachtstrom oder §14a Modul 3 (zeitvariables Netzentgelt). Gelten mehrere Zeitzonen, zählt die letzte.',
  'tariffs.addZone': 'Zeitzone hinzufügen',
  'tariffs.removeZone': 'Zeitzone entfernen',
  'tariffs.zone.from': 'Von',
  'tariffs.zone.to': 'Bis',
  'tariffs.zone.price': 'Preis in dieser Zeit',
  'tariffs.zone.days': 'Tage (keiner gewählt: jeden Tag)',
  'tariffs.provider': 'Anbieter',
  'tariffs.providerChoose': 'Bitte wählen',
  'tariffs.charges': 'Aufschlag netto',
  'tariffs.chargesHint':
    'Bei reinem Börsenpreis: Netzentgelt, Umlagen, Stromsteuer und Marge des Anbieters, ohne Mehrwertsteuer.',
  'tariffs.tax': 'Mehrwertsteuer (%)',
  'tariffs.taxHint': 'Wird auf Börsenpreis plus Aufschlag gerechnet, in Deutschland 19 %.',
  'tariffs.feedIn': 'Einspeisung',
  'tariffs.feedInPrice': 'Einspeisevergütung',
  'tariffs.feedInHint': 'Steht im Schreiben des Netzbetreibers. Leer lassen, wenn es keine gibt.',
  'tariffs.customerHint':
    'Der Kunde sieht die Preise unter „Netz“ und kann sie dort selbst anpassen. Anbieter, Zugangsdaten und Zeitzonen ändern nur Installateure.',
  'tariffs.expert':
    'Die Tarife wurden frei in evcc eingetragen (Experten-Einstellung). Speichern ersetzt sie durch die Angaben hier.',
  'tariffs.save': 'Speichern und aktivieren',
  'tariffs.saveNext': 'Speichern, weiter',
  'tariffs.saving': 'evcc startet neu …',
  'tariffs.saved': 'Übernommen, evcc rechnet mit den neuen Preisen.',
  'wizard.tariffs.text':
    'Strompreis und Einspeisevergütung eintragen. evcc rechnet damit Kosten und Ersparnis aus und lädt bei dynamischen Tarifen in günstigen Stunden.',
  'prices.title': 'Preise',
  'prices.edit': 'Ändern',
  'prices.grid': 'Strompreis',
  'prices.zone': 'Strompreis {zone}',
  'prices.dynamic': 'Dynamisch ({provider})',
  'prices.charges': 'Aufschlag netto',
  'prices.tax': 'Mehrwertsteuer',
  'prices.feedIn': 'Einspeisevergütung',
  'prices.none': 'Noch keine Preise hinterlegt.',
  'prices.restartHint':
    'Nach dem Speichern startet das Energiemanagement kurz neu (etwa eine halbe Minute). Neue Preise gelten ab dann, frühere Kosten bleiben unverändert.',
  'prices.saving': 'Wird übernommen …',
  'prices.saved': 'Neue Preise übernommen',
  'day.mo': 'Mo',
  'day.di': 'Di',
  'day.mi': 'Mi',
  'day.do': 'Do',
  'day.fr': 'Fr',
  'day.sa': 'Sa',
  'day.so': 'So',
  'protocol.profile': 'Anlage und Kunde',
  'protocol.houseConnection': 'Hausanschluss',
  'protocol.control14a': '§14a-Steuerung',
  'installer.diagnostics': 'Diagnose',
  'installer.checklist': 'Inbetriebnahme',
  'installer.remove': 'Entfernen',
  'installer.edit': 'Bearbeiten',
  'wizard.edit': 'Gerät bearbeiten',
  'wizard.saveChanges': 'Änderungen übernehmen',
  'wizard.notFound': 'Gerät nicht gefunden',
  'wizard.rawNotEditable':
    'Dieses Gerät ist frei in evcc eingetragen (Experten-Einstellung). Ändern kann es nur ein Administrator in der evcc.yaml.',
  'installer.expert': 'Freie Konfiguration',
  'installer.sponsorToken': 'evcc-Sponsor-Token',
  'installer.siteTitle': 'Name der Anlage',
  'sponsor.holder': 'Inhaber',
  'sponsor.validUntil': 'Gültig bis',
  'sponsor.unlimited': 'unbefristet',
  'sponsor.token': 'Token',
  'sponsor.none':
    'Noch kein Sponsor-Token. Viele Wallboxen (u. a. KEBA, Mennekes) funktionieren in evcc erst mit Token.',
  'sponsor.expiresSoon': 'Das Sponsor-Token läuft in weniger als 30 Tagen ab',
  'sponsor.expiresSoonHint':
    'Ein abgelaufenes Token lässt evcc beim nächsten Neustart nicht mehr vollständig starten. Rechtzeitig ein gekauftes Token eintragen.',
  'sponsor.fromYaml': 'Das Token steht in der evcc.yaml. Ein hier eingetragenes Token hat Vorrang.',
  'sponsor.input': 'Neues Token einfügen',
  'sponsor.hint':
    'Zum Testen das öffentliche Test-Token von docs.evcc.io/de/sponsorship verwenden. Vor der Übergabe an den Kunden ein gekauftes Token (sponsor.evcc.io, ein Token pro Anlage) eintragen. evcc prüft das Token online und startet danach neu (ca. 30 Sekunden).',
  'sponsor.save': 'Token prüfen und speichern',
  'sponsor.saved': 'Token gespeichert, evcc läuft wieder',
  'sponsor.removeConfirm':
    'Token wirklich entfernen? Wallboxen, die ein Token brauchen, funktionieren dann nicht mehr.',

  'role.grid': 'Netzzähler',
  'role.pv': 'PV-Wechselrichter',
  'role.battery': 'Batteriespeicher',
  'role.aux': 'Zusätzlicher Verbraucher',
  'role.ext': 'Zusätzlicher Zähler',
  'role.charge': 'Ladezähler',
  'kind.wallbox': 'Wallbox',
  'kind.heatpump': 'Wärmepumpe',
  'kind.sgready': 'SG-Ready über Schaltkontakte',
  'kind.heatingRod': 'Heizstab an Schaltsteckdose',
  'kind.vehicle': 'Fahrzeug',
  'kind.hems': '§14a-Steuerbox',

  'wizard.step.type': 'Gerätetyp',
  'wizard.step.product': 'Produkt',
  'wizard.step.settings': 'Einstellungen',
  'wizard.search': 'Hersteller oder Modell suchen',
  'wizard.name': 'Interner Name',
  'wizard.loadpointTitle': 'Bezeichnung in der App',
  'wizard.advanced': 'Erweiterte Einstellungen',
  'wizard.test': 'Verbindung testen',
  'wizard.testOk': 'Gerät antwortet',
  'wizard.testFailed': 'Test fehlgeschlagen',
  'wizard.add': 'Zur Konfiguration hinzufügen',
  'wizard.sponsorship': 'Benötigt ein evcc-Sponsor-Token',
  'wizard.noResults': 'Keine passenden Geräte gefunden',

  'diag.evcc': 'Energiemanagement (evcc)',
  'diag.online': 'Verbunden',
  'diag.offline': 'Nicht verbunden',
  'diag.started': 'Gestartet',
  'diag.fatal': 'Startfehler',
  'diag.devices': 'Gerätestatus',
  'diag.log': 'Protokoll',
  'diag.refresh': 'Aktualisieren',

  'checklist.title': 'Inbetriebnahme-Checkliste',
  'checklist.customer': 'Kunde',
  'checklist.installer': 'Monteur',
  'checklist.print': 'Als PDF speichern',
  'checklist.saved': 'Gespeichert',
  'nav.protocol': 'Protokoll',
  'protocol.title': 'Inbetriebnahme-Protokoll',
  'protocol.site': 'Anlage',
  'protocol.completedAt': 'Abgeschlossen am',
  'protocol.software': 'Software',
  'protocol.devices': 'Eingerichtete Geräte',
  'protocol.measurements': 'Messwerte bei Übergabe',
  'protocol.checks': 'Prüfungen',
  'protocol.done': 'erledigt',
  'protocol.notDone': 'nicht erledigt',
  'protocol.signInstaller': 'Unterschrift Monteur',
  'protocol.signCustomer': 'Unterschrift Kunde',
  'protocol.signature': 'Unterschrift',
  'protocol.notSigned': 'Noch nicht unterschrieben',
  'protocol.signIntro':
    'Zum Abschluss unterschreiben Monteur und Kunde hier mit dem Finger oder der Maus. Danach ist das Protokoll gesperrt.',
  'protocol.signHere': 'Im weißen Feld unterschreiben',
  'protocol.clear': 'Löschen',
  'protocol.name': 'Name in Druckbuchstaben',
  'protocol.sign': 'Unterschreiben',
  'protocol.signed': 'unterschrieben',
  'protocol.locked': 'Das Protokoll ist von Monteur und Kunde unterschrieben und gesperrt.',
  'protocol.share': 'Für den Kunden sichtbar',
  'protocol.shareHint':
    'Der Kunde findet das Protokoll dann jederzeit in seiner App unter „Protokoll“ und kann es drucken.',
  'protocol.reopen': 'Protokoll wieder öffnen',
  'protocol.reopenConfirm':
    'Protokoll wieder öffnen? Beide Unterschriften werden entfernt, und die Freigabe für den Kunden endet. Danach muss neu unterschrieben werden.',
  'protocol.notReleased': 'Das Inbetriebnahme-Protokoll wurde noch nicht freigegeben.',
  'protocol.open': 'Inbetriebnahme-Protokoll ansehen',
  'protocol.kind.grid': 'Netzzähler',
  'protocol.kind.pv': 'PV-Wechselrichter',
  'protocol.kind.battery': 'Speicher',
  'protocol.kind.charge': 'Ladezähler',
  'protocol.kind.aux': 'Verbraucher',
  'protocol.kind.ext': 'Zusatzzähler',
  'protocol.kind.charger': 'Wallbox / Wärmepumpe',
  'protocol.kind.vehicle': 'Fahrzeug',

  'nav.sites': 'Anlagen',
  'sites.title': 'Anlagen',
  'sites.create': 'Anlage anlegen',
  'sites.siteTitle': 'Name der Anlage (z. B. Familie Müller)',
  'sites.none': 'Noch keine Anlage. Ihr Installateur lädt Sie ein, sobald Ihre Anlage eingerichtet ist.',
  'sites.online': 'Online',
  'sites.offline': 'Offline',
  'sites.notPaired': 'Kein Gerät gekoppelt',
  'sites.open': 'Diese Anlage anzeigen',
  'sites.switch': 'Anlage wechseln',
  'sites.pairingCode': 'Kopplungscode vom QR-Aufkleber des Geräts',
  'sites.pairingHint':
    'Der Pi muss eingeschaltet und mit dem Internet verbunden sein. Den Code per QR-Scanner oder von Hand übertragen.',
  'sites.pair': 'Gerät koppeln',
  'sites.device': 'Gerät',
  'sites.unpair': 'Gerät entkoppeln',
  'sites.unpairConfirm': 'Gerät wirklich entkoppeln? Der Fernzugriff auf diese Anlage endet sofort.',
  'sites.members': 'Zugriff',
  'sites.invite': 'Einladen',
  'sites.inviteCreated': 'Einladungslink erstellt (14 Tage gültig). Bitte an die Person weitergeben:',
  'sites.copy': 'Kopieren',
  'sites.roleLabel': 'Rolle',
  'sites.role.owner': 'Eigentümer',
  'sites.role.member': 'Mitglied',
  'sites.role.installer': 'Installateur',
  'sites.noSite': 'Bitte zuerst eine Anlage auswählen.',
  'sites.siteOffline':
    'Die Anlage ist gerade nicht mit STE Connect verbunden. Vor Ort funktioniert sie weiter.',

  'invite.title': 'Einladung zu ste.box',
  'invite.text': 'Sie wurden zur Anlage „{site}“ als {role} eingeladen.',
  'invite.existing':
    'Für diese E-Mail gibt es bereits ein Konto. Bitte zuerst anmelden und den Link danach erneut öffnen.',
  'invite.name': 'Ihr Name',
  'invite.password': 'Passwort (mindestens 10 Zeichen)',
  'invite.accept': 'Einladung annehmen',

  'nav.notifications': 'Meldungen',
  'notifications.title': 'Benachrichtigungen',
  'notifications.push': 'Push-Mitteilungen',
  'notifications.appHint': 'Wählen Sie, worüber dieses Telefon Sie informiert.',
  'notifications.browserHint':
    'Push-Mitteilungen kommen auf Ihr Telefon, sobald Sie sich in der App ste.box für iPhone oder Android anmelden. Hier legen Sie fest, welche Meldungen Sie erhalten.',
  'notifications.forSite': 'Die Auswahl gilt für die Anlage „{site}“.',
  'notifications.gatewayOnly':
    'Push-Mitteilungen auf das Telefon gibt es mit STE Connect in der App ste.box. Ihr Installateur richtet den Zugang ein. Die letzten Meldungen sehen Sie auch hier.',
  'notifications.serverOff':
    'Der Push-Versand ist auf dem Server noch nicht eingerichtet (Firebase-Zugang fehlt). Einstellungen werden trotzdem gespeichert.',
  'notifications.event.charge.finished': 'Laden beendet',
  'notifications.event.vehicle.target_reached': 'Ziel-Ladestand erreicht',
  'notifications.event.device.fault': 'Störung',
  'notifications.event.gateway.offline': 'Anlage nicht erreichbar',
  'notifications.event.grid.dimmed': '§14a-Dimmung durch den Netzbetreiber',
  'notifications.event.network.wifi_weak': 'Schwaches WLAN-Signal (Installateur)',
  'notifications.hint.charge.finished': 'Das Fahrzeug lädt nicht mehr, weil es voll ist.',
  'notifications.hint.vehicle.target_reached': 'Der eingestellte Ladestand ist erreicht.',
  'notifications.hint.device.fault': 'Wallbox, Wärmepumpe oder Energiemanager melden einen Fehler.',
  'notifications.hint.gateway.offline': 'Das STE-Gateway meldet sich seit 10 Minuten nicht.',
  'notifications.hint.grid.dimmed': 'Wallbox und Wärmepumpe sind vorübergehend begrenzt.',
  'notifications.hint.network.wifi_weak':
    'Das Gerät hängt seit 15 Minuten nur schwach im WLAN (unter 40 %). Höchstens einmal am Tag.',
  'notifications.saveFailed': 'Einstellung konnte nicht gespeichert werden',
  'notifications.test': 'Testmeldung senden',
  'notifications.testSent': 'Testmeldung an {n} Gerät(e) gesendet',
  'notifications.testFailed': 'Kein Gerät hat die Testmeldung angenommen',
  'notifications.noDevices': 'Noch kein Telefon angemeldet',
  'notifications.devices': '{n} Telefon(e) angemeldet',
  'notifications.log': 'Letzte Meldungen',
  'notifications.logEmpty': 'Noch keine Meldungen.',
  'notifications.logUnavailable': 'Meldungen können gerade nicht geladen werden.',
  // two-factor setup (STE Connect, ADR-0013)
  'totp.title': 'Zwei-Faktor-Anmeldung einrichten',
  'totp.intro':
    'Für dieses Konto ist ein zweiter Faktor Pflicht. Sie brauchen dafür eine Authenticator-App auf dem Handy, zum Beispiel Google Authenticator, Microsoft Authenticator oder die Passwörter-App auf dem iPhone.',
  'totp.step1': 'Authenticator-App öffnen und „Konto hinzufügen“ wählen.',
  'totp.step2': 'Diesen QR-Code scannen.',
  'totp.openApp': 'Auf diesem Handy: direkt in der App öffnen',
  'totp.manual': 'Ohne Kamera: Schlüssel von Hand eingeben',
  'totp.step3': 'Den 6-stelligen Code aus der App hier eingeben.',
  'totp.code': '6-stelliger Code',
  'totp.confirm': 'Bestätigen und anmelden',
  'totp.qrAlt': 'QR-Code für die Authenticator-App',
  'totp.expired': 'Die Einrichtung hat zu lange gedauert. Bitte erneut anmelden.',
  // STE team (admins)
  'nav.team': 'Team',
  'team.title': 'STE-Team',
  'team.intro':
    'Hier laden Sie Installateure und Admins ein und sperren Zugänge. Neue Mitarbeiter setzen ihr Passwort selbst und richten die Zwei-Faktor-Anmeldung ein.',
  'team.invite': 'Mitarbeiter einladen',
  'team.name': 'Name',
  'team.role.installer': 'Installateur',
  'team.role.admin': 'Admin',
  'team.roleHint': 'Installateure betreuen alle Anlagen. Admins können zusätzlich das Team verwalten.',
  'team.inviteCreated':
    'Einladungslink erstellt. Bitte per E-Mail oder Messenger an die Person schicken. Er gilt 7 Tage und nur einmal.',
  'team.copy': 'Link kopieren',
  'team.copied': 'Kopiert',
  'team.open': 'Offene Einladungen',
  'team.validUntil': 'gültig bis {date}',
  'team.revoke': 'Einladung zurückziehen',
  'team.members': 'Mitarbeiter',
  'team.you': 'Sie',
  'team.locked': 'Gesperrt',
  'team.lastLogin': 'Zuletzt angemeldet: {date}',
  'team.neverLoggedIn': 'Noch nie angemeldet',
  'team.noTotp': 'Zwei-Faktor fehlt',
  'team.lock': 'Sperren',
  'team.unlock': 'Entsperren',
  'team.lockConfirm':
    '{name} sperren? Die Person wird sofort abgemeldet und kann sich weder in STE Connect noch direkt am Pi anmelden.',
  'team.makeAdmin': 'Zum Admin machen',
  'team.makeInstaller': 'Zum Installateur machen',
  'team.manage': 'Team verwalten',
  'teamInvite.title': 'Willkommen im STE-Team',
  'teamInvite.text': 'Sie wurden als {role} zu STE Connect eingeladen.',
  'teamInvite.account': '1. Ihr Zugang',
  'teamInvite.second': '2. Zwei-Faktor-Anmeldung',
  'teamInvite.submit': 'Zugang anlegen',
  'teamInvite.passwordHint': 'Mindestens 10 Zeichen. Am besten einen Passwort-Manager nutzen.',
  // settings for the customer (ADR-0014)
  'settings.title': 'Einstellungen',
  'settings.account': 'Mein Konto',
  'settings.roleOnSite': 'Rolle auf dieser Anlage',
  'settings.appearance': 'Darstellung',
  'settings.service': 'Installateur-Bereich',
  'settings.serviceIntro':
    'Hier lassen sich Geräte und Einstellungen der Anlage ändern. Bitte nur nach Absprache mit STE: Falsche Einstellungen können das Laden oder die Heizung stören. Das Service-Passwort erhalten Sie von STE.',
  'settings.servicePassword': 'Service-Passwort',
  'settings.serviceUnlock': 'Installateur-Bereich öffnen',
  'settings.serviceOpen': 'Der Installateur-Bereich ist bis {time} Uhr geöffnet.',
  'settings.serviceGo': 'Zum Installateur-Bereich',
  'settings.serviceLock': 'Wieder schließen',
  'settings.password': 'Passwort ändern',
  'settings.passwordCurrent': 'Aktuelles Passwort',
  'settings.passwordNext': 'Neues Passwort (mindestens 10 Zeichen)',
  'settings.passwordSave': 'Passwort ändern',
  'settings.passwordDone': 'Passwort geändert. Bitte melden Sie sich mit dem neuen Passwort an.',
  'settings.passwordLocal':
    'Das Passwort ändern Sie in der App ste.box oder unter STE Connect. Am Gerät gilt danach automatisch das neue Passwort.',
  'settings.data': 'Daten und Konto',
  'settings.export': 'Meine Daten herunterladen',
  'settings.delete': 'Konto löschen',
  'settings.deleteText':
    'Ihr Zugang wird gelöscht. Die Anlage und ihre Messwerte bleiben erhalten; andere Mitglieder können sie weiter nutzen.',
  'settings.deleteConfirm': 'Zum Bestätigen Ihr Passwort eingeben',
  'settings.deleteFinal': 'Konto endgültig löschen',
  // service password for STE admins (installer area)
  'servicePassword.title': 'Service-Passwort für den Kunden',
  'servicePassword.text':
    'Damit öffnet der Kunde unter „Einstellungen“ den Installateur-Bereich für eine Stunde. Nur nach Absprache weitergeben, am besten am Telefon. Danach neu erzeugen.',
  'servicePassword.show': 'Anzeigen',
  'servicePassword.hide': 'Verbergen',
  'servicePassword.regenerate': 'Neu erzeugen',
  'servicePassword.regenerateConfirm':
    'Neues Service-Passwort erzeugen? Das bisherige gilt dann nicht mehr, auch nicht am Gerät.',
  'servicePassword.custom': 'Eigenes Passwort (mindestens 8 Zeichen)',
  'servicePassword.updated': 'Zuletzt geändert: {date}',
  // forgot password (ADR-0015)
  'reset.forgot': 'Passwort vergessen?',
  'reset.forgotText':
    'Bitte melden Sie sich bei STE oder Ihrem Installateur. Sie bekommen einen Link, mit dem Sie selbst ein neues Passwort festlegen.',
  'reset.forgotMail':
    'Geben Sie Ihre E-Mail-Adresse ein. Sie bekommen einen Link, mit dem Sie ein neues Passwort festlegen.',
  'reset.forgotSend': 'Link per E-Mail schicken',
  'reset.forgotSent':
    'Wenn es ein Konto mit dieser Adresse gibt, kommt gleich eine E-Mail mit dem Link. Bitte auch im Spam-Ordner nachsehen.',
  // e-mail delivery (ADR-0027)
  'mail.sentTo': 'E-Mail an {email} verschickt. Den Link können Sie zusätzlich selbst weitergeben:',
  'reset.create': 'Link zum Zurücksetzen',
  'reset.lostPhone': 'Handy verloren: Zwei-Faktor-Anmeldung neu einrichten',
  'reset.createButton': 'Link erstellen',
  'reset.created':
    'Link erstellt. Bitte an die Person schicken, er gilt 24 Stunden und nur einmal. Das neue Passwort tippt die Person selbst ein.',
  'reset.title': 'Neues Passwort festlegen',
  'reset.for': 'Für {email}',
  'reset.password': 'Neues Passwort (mindestens 10 Zeichen)',
  'reset.passwordRepeat': 'Neues Passwort wiederholen',
  'reset.mismatch': 'Die beiden Passwörter sind nicht gleich.',
  'reset.totpHint': 'Zur Sicherheit: den aktuellen Code aus Ihrer Authenticator-App.',
  'reset.submit': 'Passwort speichern',
  'reset.done': 'Ihr neues Passwort ist gespeichert. Bitte melden Sie sich jetzt damit an.',
  'reset.toLogin': 'Zur Anmeldung',
  'team.delete': 'Löschen',
  'team.deleteConfirm':
    '{name} endgültig löschen? Der Zugang verschwindet aus der Liste. Was die Person getan hat, bleibt im Protokoll.',
  // device serial, emergency login, device passport (ADR-0016)
  'recovery.open': 'Notfall-Zugang (ohne Konto)',
  'recovery.title': 'Notfall-Zugang',
  'recovery.text':
    'Das Notfall-Passwort steht auf dem Gerätepass dieses Geräts. Es öffnet für 60 Minuten den Installateur-Bereich, auch ohne Internet.',
  'recovery.password': 'Notfall-Passwort',
  'recovery.submit': 'Mit Notfall-Passwort anmelden',
  'recovery.back': 'Zurück zur normalen Anmeldung',
  'device.serial': 'Seriennummer',
  'passport.title': 'Gerätepass',
  'passport.text':
    'Notfall-Zugang und Einrichtungs-WLAN dieses Geräts. Gehört in die STE-Unterlagen, nicht an das Gerät. Jedes Anzeigen wird protokolliert.',
  'passport.recovery': 'Notfall-Passwort',
  'passport.wifi': 'Einrichtungs-WLAN',
  'passport.wifiKey': 'WLAN-Schlüssel',
  'passport.missing': 'Noch nicht gemeldet (Gerät mit älterer Version)',
  // network of the Pi (ADR-0016)
  'installer.network': 'Netzwerk',
  'net.title': 'Netzwerk',
  'net.unavailable':
    'Die Netzwerk-Verwaltung fehlt auf diesem Gerät. Sie kommt mit dem neuen Pi-Bundle (provision.sh erneut ausführen).',
  'net.current': 'Aktuelle Verbindung',
  'net.mode.ethernet': 'Netzwerkkabel',
  'net.mode.wifi': 'WLAN „{ssid}“',
  'net.mode.setup': 'Einrichtungs-WLAN „{ssid}“ ist offen',
  'net.mode.none': 'Keine Verbindung',
  'net.address': 'Adresse',
  'net.setupHint':
    'Das Gerät hat kein Netzwerk gefunden und sein Einrichtungs-WLAN geöffnet. Wählen Sie unten das WLAN des Kunden.',
  'net.choose': 'WLAN des Kunden wählen',
  'net.scan': 'Neu suchen',
  'net.noNetworks': 'Noch keine WLANs gefunden. „Neu suchen“ antippen.',
  'net.open': 'offen',
  'net.ssid': 'WLAN-Name',
  'net.key': 'WLAN-Schlüssel',
  'net.connect': 'Verbinden',
  'net.connectWarning':
    'Das Gerät wechselt jetzt ins gewählte WLAN. Läuft diese Seite über das Einrichtungs-WLAN, bricht die Verbindung ab: Handy wieder ins Kunden-WLAN, dann ist das Gerät unter https://ste-ems.local:8443 erreichbar. Klappt die Verbindung nicht, öffnet sich das Einrichtungs-WLAN nach etwa zwei Minuten wieder und zeigt hier den Fehler.',
  'net.remoteWarning':
    'Achtung: Sie sind über STE Connect verbunden. Ein falsches WLAN trennt das Gerät auch von STE Connect; dann hilft nur das Einrichtungs-WLAN vor Ort.',
  'net.pending': 'Auftrag wird ausgeführt …',
  'net.forget': 'WLAN vergessen',
  'net.forgetConfirm':
    'Das gespeicherte WLAN entfernen? Ohne Netzwerkkabel ist das Gerät danach offline und öffnet sein Einrichtungs-WLAN.',
  'net.last': 'Letzter Auftrag',
  'net.signal': 'Signal {n} %',
  // network page, second iteration (ADR-0016)
  'net.lan': 'LAN (Netzwerkkabel)',
  'net.wlan': 'WLAN',
  'net.noCable': 'Kein Kabel eingesteckt',
  'net.cableNoAddress': 'Kabel steckt, aber keine Adresse vom Router',
  'net.connected': 'Verbunden',
  'net.notConnected': 'Nicht verbunden',
  'net.wifiSetup': 'Sendet das Einrichtungs-WLAN „{ssid}“',
  'net.inUse': 'wird genutzt',
  'net.notAvailableDevice': 'Auf diesem Gerät nicht vorhanden',
  'net.ip': 'IP-Adresse',
  'net.router': 'Router (Gateway)',
  'net.dns': 'DNS',
  'net.mac': 'MAC-Adresse',
  'net.frequency': 'Frequenz',
  'net.ghz24': '2,4 GHz',
  'net.ghz5': '5 GHz',
  'net.signalLabel': 'Signal',
  'net.signalWeak': 'schwach',
  'net.signalOk': 'mittel',
  'net.signalGood': 'gut',
  'net.updateBundle':
    'Für Details zu LAN und WLAN, Verbindungstest und gespeicherte WLANs bitte das Pi-Bundle aktualisieren (provision.sh erneut ausführen).',
  'net.setupReason.offline': 'Das Gerät hat kein Netzwerk gefunden.',
  'net.setupReason.unpaired':
    'Das Gerät ist noch nicht gekoppelt und hängt am Kabel: Das Einrichtungs-WLAN bleibt bis {time} Uhr offen.',
  'net.setupReason.manual': 'Von Hand geöffnet, bis {time} Uhr.',
  'net.test': 'Verbindungstest',
  'net.testRun': 'Verbindung testen',
  'net.testRunning': 'Test läuft …',
  'net.testNever': 'Prüft Netzwerk, Router, Namensauflösung, STE Connect und Fernzugang.',
  'net.testAt': 'Getestet um {time} Uhr',
  'net.testStep.network': 'Netzwerk',
  'net.testStep.gateway': 'Router erreichbar',
  'net.testStep.dns': 'Namensauflösung (DNS)',
  'net.testStep.cloud': 'STE Connect erreichbar',
  'net.testStep.tunnel': 'Fernzugang (Tunnel)',
  'net.testSkipped': 'entfällt, Gerät noch nicht gekoppelt',
  'net.testHint.network': 'Kabel prüfen oder ein WLAN wählen.',
  'net.testHint.gateway': 'Router eingeschaltet? Kabel oder WLAN-Signal prüfen.',
  'net.testHint.dns': 'Der Router löst keine Namen auf. Router neu starten oder Internetanbieter prüfen.',
  'net.testHint.cloud': 'Kein Internet oder eine Firewall sperrt HTTPS (Port 443) nach außen.',
  'net.testHint.tunnel': 'Eine Firewall sperrt vermutlich UDP 51820 nach außen (Firmennetz?).',
  'net.saved': 'Gespeicherte WLANs',
  'net.savedHint': 'Das Gerät nimmt das erste verfügbare WLAN der Liste.',
  'net.savedNone': 'Noch keine WLANs gespeichert.',
  'net.moveUp': 'Nach oben',
  'net.moveDown': 'Nach unten',
  'net.forgetSaved': 'Entfernen',
  'net.forgetSavedConfirm':
    '„{ssid}“ entfernen? Das Gerät verbindet sich danach nicht mehr von selbst damit.',
  'net.setup': 'Einrichtungs-WLAN',
  'net.setupText':
    'Öffnet das eigene WLAN des Geräts für 30 Minuten, z. B. bevor es zum Kunden geht. Name und Schlüssel stehen auf dem Gerätepass.',
  'net.setupOpen': 'Für 30 Minuten öffnen',
  'net.setupClose': 'Jetzt schließen',
  'net.setupWifiWarning':
    'Achtung: Das Gerät ist gerade per WLAN verbunden. Der WLAN-Chip kann nur eins von beiden: Solange das Einrichtungs-WLAN offen ist, ist das Gerät offline.',
  'net.dialog.title': 'Verbindung mit „{ssid}“',
  'net.dialog.wait': 'Das kann bis zu 2 Minuten dauern. Bitte die Seite offen lassen.',
  'net.dialog.step.send': 'Auftrag an das Gerät',
  'net.dialog.step.connect': 'Mit „{ssid}“ verbinden',
  'net.dialog.step.address': 'Adresse vom Router holen',
  'net.dialog.step.cloud': 'STE Connect prüfen',
  'net.dialog.ok': 'Verbunden mit „{ssid}“',
  'net.dialog.okAddress': 'Das Gerät hat die Adresse {address}.',
  'net.dialog.okNoCloud':
    'Das Gerät ist im WLAN, erreicht STE Connect aber nicht. Unten den Verbindungstest ansehen.',
  'net.dialog.failed': 'Verbindung fehlgeschlagen',
  'net.dialog.lost': 'Verbindung zum Gerät unterbrochen',
  'net.dialog.lostText':
    'Das ist normal, wenn Sie über das Einrichtungs-WLAN verbunden sind: Das Gerät wechselt gerade ins neue WLAN. So geht es weiter:',
  'net.dialog.lostStep1': 'Handy oder Laptop ins WLAN „{ssid}“ wechseln.',
  'net.dialog.lostStep2': 'https://ste-ems.local:8443 öffnen und erneut anmelden.',
  'net.dialog.lostStep3':
    'Klappt das nicht, öffnet sich nach etwa 2 Minuten wieder das Einrichtungs-WLAN und zeigt den Fehler.',
  'net.dialog.timeout':
    'Keine Rückmeldung vom Gerät. Bitte die Seite neu laden und den letzten Auftrag ansehen.',
  'net.dialog.close': 'Schließen',
} as const;

export type MessageKey = keyof typeof de;
